import type { SessionBody } from '@/shared/api/generated/model';
import { appConfig } from '@/shared/config';

import { clearSession, setSession } from './session';

/**
 * Обновление доступа по cookie.
 *
 * Идёт голым `fetch`, а не через общий `facetaFetch`, намеренно: тот при
 * ответе 401 сам зовёт обновление, и обновление через него зациклилось бы на
 * первом же протухшем токене.
 */

let inFlight: Promise<boolean> | null = null;

/**
 * Обновляет сеанс. Одновременные вызовы делят один запрос.
 *
 * Единый поток здесь обязателен: после протухания токена все запросы экрана
 * получают 401 разом. Без него десяток запросов начал бы десять обновлений,
 * а поскольку токен обновления одноразовый, девять из них были бы приняты за
 * попытку кражи — и человека выкинуло бы из системы за то, что он открыл
 * страницу с несколькими таблицами.
 */
export function refreshSession(): Promise<boolean> {
  inFlight ??= run().finally(() => {
    inFlight = null;
  });

  return inFlight;
}

async function run(): Promise<boolean> {
  const base = appConfig.apiBaseUrl.replace(/\/$/, '');

  try {
    const response = await fetch(`${base}/auth/refresh`, {
      method: 'POST',
      headers: { Accept: 'application/json' },
    });

    if (!response.ok) {
      clearSession();

      return false;
    }

    const body = (await response.json()) as SessionBody;

    setSession(body.access_token, body.user, body.impersonated);

    return true;
  } catch {
    // Сеть отвалилась. Сеанс не трогаем: обрыв связи — не повод считать
    // человека вышедшим, он вернётся на ту же страницу.
    return false;
  }
}
